import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import useUpdateIaTraining from '../Hooks/IAtrainingHooks/useUpdateIaTraining'; 
import MunicipalitySelector from '../Components/Municipality';
import ProvinceSelector from '../Components/ProvinceSelector';
import adminBg from '../Assets/bg/adminbg.jpg';

const IaProfilingEdit = ({ selectedItem, closeEditPanel, darkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};  // You can remove this if it's not being used elsewhere.

  const [formData, setFormData] = useState({
    region: '',
    imo: '',
    province: '',
    municipality: '',
    projectName: '',
    ia_name: '',
    trainingsConducted_regular: '',
    trainingsConducted_other: '',
    batchesNum_regular: '',
    batchesNum_other: '',
    dateConducted_regular: '',
    dateConducted_other: '',
    participantsNum_regular: '',
    participantsNum_other: '',
    venue_regular: '',
    venue_other: '',
  });

  const { loading, error, success, updateIaTraining } = useUpdateIaTraining();

  // Populate form with selectedItem data when it changes
  useEffect(() => {
    if (selectedItem) {
      setFormData({
        region: selectedItem. region,
        imo: selectedItem. imo,
        province: selectedItem.province,
        municipality: selectedItem.municipality,
        projectName: selectedItem. projectName,
        ia_name: selectedItem.ia_name,
        trainingsConducted_regular: selectedItem.trainingsConducted_regular,
        trainingsConducted_other: selectedItem.trainingsConducted_other,
        batchesNum_regular: selectedItem.batchesNum_regular,
        batchesNum_other: selectedItem.batchesNum_other,
        dateConducted_regular: selectedItem. dateConducted_regular,
        dateConducted_other: selectedItem.dateConducted_other,
        participantsNum_regular: selectedItem.participantsNum_regular,
        participantsNum_other: selectedItem.participantsNum_other,
        venue_regular: selectedItem.venue_regular,
        venue_other: selectedItem.venue_other,
      });
    }
  }, [selectedItem]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cis_id = selectedItem?.id;  // Use the row id from selectedItem

    if (!cis_id) {
      alert('Invalid ID, please try again.');
      return;
    }

    await updateIaTraining(cis_id, formData);

    if (success) {
      alert('Profile updated successfully!');
      closeEditPanel();  // Close the edit panel after successful update
      navigate('/');  // Navigate to another page, adjust if necessary
    } else if (error) {
      alert('Error: ' + error);
    }
  };

  const closePanel = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <SlidingPanel darkMode={darkMode} show={true} >
      <TopPanel>
        <CloseButton onClick={closeEditPanel}>
          <span>{'<'}</span>
        </CloseButton>

        <FormTitle>Edit IA Training</FormTitle>
        <FormButton type="submit" onClick={handleSubmit}>Save Changes</FormButton>
      </TopPanel>
      <ScrollableContainer>
        <Form onSubmit={handleSubmit}>
        <FormGrid>
        <FieldGroup>
           <label>REGION</label>
          <input
             type="text"
             name=" region"
              value={formData.region}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>IMO</label>
         <input
             type="text"
             name=" imo"
              value={formData.imo}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup darkMode={darkMode}>
              <label>PROVINCE</label>
             <MunicipalitySelector formData={formData} setFormData={setFormData} darkMode={darkMode} />
        </FieldGroup>

         <FieldGroup darkMode={darkMode}>
              <label>MUNICIPALITY</label>
            <ProvinceSelector formData={formData} setFormData={setFormData} darkMode={darkMode} />
        </FieldGroup>

         <FieldGroup>
         <label>NAME OF PROJECT/SYSTEM</label>
         <input
             type="text"
             name="projectName"
              value={formData.projectName}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>NAME OF IRRIGATORS' ASSOCIATION</label>
         <input
             type="text"
             name="ia_name"
              value={formData.ia_name}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>TRAININGS CONDUCTED(regular) </label>
         <input
             type="text"
             name="trainingsConducted_regular"
              value={formData.trainingsConducted_regular}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>TRAININGS CONDUCTED(other)</label>
         <input
             type="text"
             name="trainingsConducted_other"
              value={formData.trainingsConducted_other}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>NO. OF BATCHES (regular)</label>
         <input
             type="text"
             name="batchesNum_regular"
              value={formData.batchesNum_regular}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>NO. OF BATCHES (other)</label>
         <input
             type="text"
             name="batchesNum_other"
              value={formData.batchesNum_other}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>DATE CONDUCTED(regular)</label>
         <input
             type="text"
             name="ia_tin"
              value={formData.ia_tin}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>DATE CONDUCTED(other)</label>
         <input
             type="text"
             name="dateConducted_other"
              value={formData.dateConducted_other}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>NO. OF PARTICIPANTS(regular)</label>
         <input
             type="text"
             name="participantsNum_regular"
              value={formData.participantsNum_regular}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>NO. OF PARTICIPANTS(other)</label>
         <input
             type="text"
             name="participantsNum_other"
              value={formData.participantsNum_other}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>VENUE(regular)</label>
         <input
             type="text"
             name="venue_regular"
              value={formData.venue_regular}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>VENUE(other)</label>
         <input
             type="text"
             name="venue_other"
              value={formData.venue_other}
              onChange={handleInputChange}
          />
         </FieldGroup>

         
     
            </FormGrid>
        </Form>
      </ScrollableContainer>
    </SlidingPanel>
  );
};

export default IaProfilingEdit;

// Styled components remain unchanged


const SlidingPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  
  background-size: cover;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const TopPanel = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  padding: 5px 5px;
`;


const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 20px;
  margin-left: -29px;
  padding: 10px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormTitle = styled.h2`
  font-size: 15px;
  color: #333;
  font-weight: bold;
  margin-top: 30px;
`;

const FormGrid = styled.div`
 display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns */
  gap: 20px;
  padding: 5px;

  background-color: ${({ darkMode }) => (darkMode ? 'rgb(36, 110, 45)' : '#f9f9f9')};
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #f2f2f2;
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-weight: bold;
    font-size: .75rem;
    margin-bottom: 5px;
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  }

  input {
    padding: 3px;
    font-size: 1rem;
    border-radius: 6px;
    border: 1px solid ;
    color: ${({ darkMode }) => (darkMode ? '#333' : '#333')};
    background-color: ${({ darkMode }) => (darkMode ? '#dcdcdc' : '#f2f2f2')};
    width: 100%;
  }
`;

const FormButton = styled.button`
  padding: 8px 5px;
  font-size: 13px;
  background-color: #218838;
  color: white;
  margin-top: 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #1c7c2a;
  }
`;

const ScrollableContainer = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  padding-right: 10px;
`;
